export enum SearchOperators {
    BETWEEN = 'range',
    EQUAL_TO = 'equals',
    GREATER_THAN = 'above',
    LESS_THAN = 'below',
    NOT_EQUAL_TO = 'notequal',
}

export enum SearchOperatorsEnum {
    BETWEEN = 'range',
    EQUAL_TO = 'equals',
    GREATER_THAN = 'above',
    LESS_THAN = 'below',
    NOT_EQUAL_TO = 'notequal',
}

export type SearchOperatorsKeys = keyof typeof SearchOperators
export type SearchOperatorsValues = `${SearchOperators}`

export enum NotSearchOperators {
    EQUAL_TO = 'equals',
    NOT_EQUAL_TO = 'notequal',
}

export enum NotSearchOperatorsEnum {
    EQUAL_TO = 'equals',
    NOT_EQUAL_TO = 'notequal',
}
export type NotSearchOperatorsKeys = keyof typeof NotSearchOperators
export type NotSearchOperatorsValues = `${NotSearchOperators}`

export type YearOperator = Exclude<SearchOperatorsValues, `${SearchOperators.NOT_EQUAL_TO}`>
export type OdometerOperator = Exclude<SearchOperatorsValues, `${SearchOperators.NOT_EQUAL_TO}`>
export type LowHighOperator = Exclude<SearchOperatorsValues, `${SearchOperators.NOT_EQUAL_TO}`>

export type NotOperator = Extract<
    SearchOperatorsValues,
    `${SearchOperators.EQUAL_TO}` | `${SearchOperators.NOT_EQUAL_TO}`
>

export default SearchOperators
